import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { showSnoozeBlocker } from '../../../../../base/effects/showSnoozeBlocker';

export const checkTabExportPermission = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(showSnoozeBlocker({
            allow: 'allowGoogleSheetExport'
        }));
    };
    return action;
};
